<template>
    <v-btn x-small text class="d-inline" :class="{ ['font-weight-bold']: lecture.code.isOn }" @click="copy">
        <template v-if="lecture.code.isOn"> 참여코드 : {{ lecture.code.text }} </template>
        <template v-else> 누구나 참여 가능 </template>
    </v-btn>
</template>

<script>
import { mapState } from "vuex";

export default {
    computed: {
        ...mapState("lecture", ["lecture"]),
    },
    methods: {
        copy() {
            if (!this.lecture.code.isOn) return;

            let text = this.lecture.code.text;
            navigator.clipboard.writeText(text).then(() => alert("참여코드가 복사되었습니다"));
        },
    },
};
</script>

<style>
</style>